module.exports = __webpack_public_path__ + "img/t2-3.26009e47.svg";